




































































import Vue from 'vue'
import ProgressBar from '@/components/sub-components/ProgressBar.vue'
import ProgressCircle from '@/components/sub-components/ProgressCircle.vue'
import BarChartWithRatio from '@/components/care-team-dashboard/BarChartWithRatio.vue'
import { round, withUnit } from '@/components/exercises/measure/filters'

export default Vue.extend({
  components: {
    ProgressBar,
    ProgressCircle,
    BarChartWithRatio,
  },
  filters: {
    withUnit,
    round,
  },
  props: {
    siteStats: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      progress: 15,
    }
  },
})
